export enum InsulinAdministrationMethod {
  INJECTION = 0,
  PUMP = 1,
}
